import React from "react";
import { SITE } from "../../lib/siteData";

export const KnightLogo = ({ className = "h-9 w-auto", tone = "dark" }) => {
  // Transparent PNG — renders cleanly on light backgrounds. On dark backgrounds
  // we use a brightness filter to flip the navy artwork to a soft white-blue
  // so the logo stays readable.
  const filter = tone === "light" ? "brightness(0) invert(1)" : "none";
  return (
    <img
      src={SITE.logo_image}
      alt="Knight Insurance Solutions"
      className={className}
      style={{ filter, objectFit: "contain" }}
    />
  );
};

export default KnightLogo;
